module.exports = __webpack_public_path__ + "static/img/icon_languages@2x.1a38e627.png";